<template>
    <div class="col align-self-end px-0">
        <div v-if="bannerLabel !== ''">
            <p class="ob1-tag ob1-tag-primary" v-html="bannerLabel" />
        </div>
        <contract-phone-lines
            v-if="contractInfos"
            class="mt-1 mt-md-0 mb-1"
            :contract-infos="contractInfos"
        />
        <h4
            class="m-0"
            th:classappend="${isShopSosh} ? 'text-dark' : 'text-white'"
            v-text="label"
        />
        <ob1-prix-offre
            :duration="priceBlock.prixDTO.duration"
            :initial-price="priceBlock.prixDTO.initialPrice"
            :price="priceBlock.prixDTO.price"
            :price-details="priceBlock.prixDTO.priceDetails"
            :show-by-month="priceBlock.prixDTO.showByMonth"
            :show-from="priceBlock.prixDTO.showFrom"
            :show-promo-duration="priceBlock.prixDTO.showPromoDuration"
            :price-label="priceBlock.priceLabel"
            custom-promo-duration="text-gray3 d-inline-block"
            custom-commitment="text-gray3"
        />
        <ob1-separateur class="my-1" />
        <p
            v-for="attribute in attributes"
            :key="attribute.picto"
            class="d-flex align-items-center"
        >
            <span
                :class="'icon ' + attribute.picto"
                style="font-size: 1.3rem; margin-right: 5px"
                aria-hidden="true"
            />
            <span>{{ attribute.description }}</span>
        </p>
        <ob1-boutons
            v-if="detailsPopin"
            is-primary
            class="my-1"
            :label="buttonLabel"
            data-bs-toggle="modal"
            :data-bs-target="'#' + detailsPopin.popinId"
            :data-oevent-category="buttonTrackZone"
            data-oevent-action="voir_detail"
            :data-oevent-label="buttonTrackCible"
        />
        <ob1-boutons
            v-else
            class="my-1"
            :label="buttonLabel"
            :is-button="true"
            :is-disabled="nextUrl === null"
            is-primary
            @ob1-boutons-click="goToNextUrl"
        />
    </div>
</template>
<script>
import ContractPhoneLines from "../common/ContractPhoneLines.vue";

export default {
    components: {ContractPhoneLines},
    props: {
        bannerLabel: {
            type: String,
            default: undefined,
            required: false
        },
        label: {
            type: String,
            required: true
        },
        buttonLabel: {
            type: String,
            required: true,
            default: ""
        },
        priceBlock: {
            type: Object,
            required: true
        },
        nextUrl: {
            type: String,
            required: false,
            default: null
        },
        attributes: {
            type: Array,
            required: false,
            default: null
        },
        contractInfos: {
            type: Object,
            default: null
        },
        buttonTrackZone: {
            type: String,
            required: true
        },
        buttonTrackNom: {
            type: String,
            required: true
        },
        buttonTrackCible: {
            type: String,
            required: true
        },
        detailsPopin: {
            type: Object,
            default: null
        }
    },
    methods:{
        goToNextUrl(){
            Tms.link({category: this.buttonTrackZone, action: this.buttonTrackNom, label: this.buttonTrackCible})
            window.location = this.nextUrl
        }
    }
}
</script>

<style scoped lang="scss">

</style>
